import { Typography } from '@mui/material';
import { NotificationDialog } from './NotificationDialog';

const OPTIMIZATIONS_DIALOG_KEY = 'optimizations-5/2';

export const OptimizationsDialog = () => {
  return (
    <NotificationDialog notificationKey={OPTIMIZATIONS_DIALOG_KEY}>
      <Typography>
        Your dashboard view has been updated. With this update, all optimization
        recommendations are now available directly in the real-time
        optimizations tab.
      </Typography>
    </NotificationDialog>
  );
};
